import type { ElementType, ReactNode } from 'react';

import { cn } from '@/lib/cn';

type SubtitleProps = {
  as?: ElementType;
  children: ReactNode;
  className?: string;
  id?: string;
};

export const Subtitle = ({ as: Component = 'p', children, className, id }: SubtitleProps) => {
  return (
    <Component id={id} className={cn('text-sm text-(--uizz-antd-color-text-tertiary)', className)}>
      {children}
    </Component>
  );
};
